// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"AnimalsInGroup_loadingOverlay__rq-mp","prevent_tiny_table":"AnimalsInGroup_prevent_tiny_table__DAmEy"};